<template>
	<div id="app">
		<app-header />
		<transition
			v-if="$store.getters['settings/isReady']"
			name="fade"
			mode="out-in"
		>
			<router-view />
		</transition>
		<p v-else class="u__padding-20">loading...</p>
		<app-footer />
		<alert-confirm />
		<div v-if="boxAlerts.length > 0" class="alert-box">
			<alert-box v-for="item in boxAlerts" :key="item.id" :item="item" />
		</div>
	</div>
</template>
<script>
import AppHeader from '@/components/Header'
import AppFooter from '@/components/Footer'
import AlertBox from '@/components/Alerts/Box'
import AlertConfirm from '@/components/Alerts/Confirm'

export default {
	components: {
		AppHeader,
		AppFooter,
		AlertBox,
		AlertConfirm
	},
	computed: {
		boxAlerts: ({ $store }) => $store.getters['alert/box']
	}
}
</script>
<style src="./assets/output.css"></style>
